<template>
    <!-- Новий дизайн (лише тут і використовується): квадрати 44×44 з кольоровою іконкою, як бейджі на картках;
         лічильник — бейдж у куті, назва — у aria-label, title і власній підказці при наведенні -->
    <div class="bp-filters" role="group" aria-label="Фільтр піц" v-if="kinds.length">
        <button v-for="kind in kinds" :key="kind.key" type="button" class="bp-filter"
                :aria-pressed="value === kind.key ? 'true' : 'false'"
                :aria-label="kind.label + ': ' + kind.count" :title="kind.label"
                @click="$emit('input', value === kind.key ? null : kind.key)">
            <span class="bp-filter__icon" v-html="value === kind.key ? kind.iconOn : kind.icon"></span>
            <span class="bp-count" aria-hidden="true">{{ kind.count }}</span>
            <span class="bp-filter__tip" aria-hidden="true">{{ kind.label }}</span>
        </button>
    </div>
</template>

<script>
import { PIZZA_KINDS, PIZZA_ICONS, PIZZA_ICONS_ON, pizzaIs } from '@/pizzaKinds'

// Кнопки «Гострі / Ситні / Вегетаріанські / З морепродуктами» над списком піц.
// v-model — ключ вибраного виду або null; повторне натискання знімає фільтр
export default {
    name: 'PizzaFilters',
    props: {
        products: Array,
        value: String,
    },
    computed: {
        kinds() {
            return PIZZA_KINDS
                .map(kind => Object.assign({}, kind, {
                    icon: PIZZA_ICONS[kind.key],
                    iconOn: PIZZA_ICONS_ON[kind.key],
                    count: this.products.filter(product => pizzaIs(kind.key, product)).length,
                }))
                // Вибрана кнопка лишається, навіть коли після пошуку таких піц 0 — щоб фільтр можна було зняти
                .filter(kind => kind.count > 0 || kind.key === this.value);
        }
    }
}
</script>
